import { InputSize } from './types';

import { IconSize } from '../Icon';

export const ICON_SIZE_BY_NAME = {
  [InputSize.SMALL]: 16,
  [InputSize.MEDIUM]: IconSize.DEFAULT,
  [InputSize.LARGE]: IconSize.DEFAULT,
};

export const PASSWORD_MIN_LENGTH = 8;
